import { Navigate, useLocation, useParams } from 'react-router-dom'

interface PathPrefixRedirectProps {
	to: string
}

// Mount on a `prefix/*` route to swap the prefix for `to`, keeping the rest of the path, query string and hash
const PathPrefixRedirect = ({ to }: PathPrefixRedirectProps) => {
	const { '*': rest } = useParams()
	const { search, hash } = useLocation()
	const path = `${to}${rest ? `/${rest}` : ''}`

	return <Navigate to={`${path}${search}${hash}`} replace />
}

export default PathPrefixRedirect
